module.exports = "<svg viewBox=\"0 0 96 96\" [attr.width]=\"width\" [attr.height]=\"height\">\n  <use [attr.href]=\"normalizedValue\" [attr.xlink:href]=\"normalizedValue\"></use>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/svg-use/svg-use.component.html
// module id = ../../../../../src/app/components/svg-use/svg-use.component.html
// module chunks = main